var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRouterAlive)?_c('div',{staticClass:"app-wrapper",class:_vm.wrapperCls},[_c('Sidebar',{staticClass:"sidebar-container"}),_c('div',{staticClass:"main-container"},[_c('Topbar',{ref:"topbar"}),_c('PageMain')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }